import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '@services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent implements OnInit, OnDestroy {
  loadings: boolean = false;
  private sub?: Subscription;

  constructor(private readonly loaderService: LoaderService, private readonly cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.sub = this.loaderService.loadings.subscribe((val) => {
      this.loadings = val;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}